import { inject, provideAppInitializer } from '@angular/core';
import { MembershipPluginsService } from '@common/membership/shared';
import { CoreFeatureModule } from '@core/frontend-shared';
import { NgxsModule } from '@ngxs/store';
import { FrontendMembershipPluginsService } from './frontend-membership-plugins.service';
import { RegistrationWrapperComponent } from './registration';
import { MembershipRegistrationState } from './state';
import { CommonModule } from '@angular/common';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
export let MembershipFrontendSharedModule = /*#__PURE__*/(() => {
  class MembershipFrontendSharedModule {
    static {
      this.ɵfac = function MembershipFrontendSharedModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MembershipFrontendSharedModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: MembershipFrontendSharedModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [{
          provide: MembershipPluginsService,
          useExisting: FrontendMembershipPluginsService
        }, provideAppInitializer(() => {
          return (service => {
            service.initialize();
          })(inject(MembershipPluginsService));
        })],
        imports: [CommonModule, CoreFeatureModule, NgxsModule.forFeature([MembershipRegistrationState]), RegistrationWrapperComponent]
      });
    }
  }
  return MembershipFrontendSharedModule;
})();